import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { PageHeader, CustomPanel, CustomCheckbox, CustomDropdown } from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'

import { tableCellCentered } from '../../../../assets/js/styles'
import useAssocEquipeSeparacao, { LOAD_MESSAGE } from './AssocEquipeSeparacaoHook'

function AssocEquipeSeparacao({ dispatch, history, selectedPicking }) {
  const { state, localDispatch } = useAssocEquipeSeparacao()

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.GET_TEAM:
        if (selectedPicking) {
          dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
          localDispatch.getEquipes(selectedPicking.tp_id)
        } else history.goBack()
        break
      case LOAD_MESSAGE.GET_ASSOC:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getAreaAndTeamAssociation(selectedPicking.id)
        break
      case LOAD_MESSAGE.SAVE_ASSOC:
        localDispatch.associateDeliveryToTeam(
          state.associationsAreaTeam,
          selectedPicking.id,
          state.selectedEquipe.id,
        )
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break
      case LOAD_MESSAGE.UPDATE_ANY_CHECKERS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break
      case LOAD_MESSAGE.SUCCESS:
        dispatch(showMessageBox(state.loadingMessage, null))
        dispatch(hideLoadingBox())
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <div>
      <PageHeader>
        <span>
          {selectedPicking.style === 'Manual'
            ? '4.4.5'
            : selectedPicking.style === 'Reconferencia'
              ? '4.8.5'
              : '4.3.5'}{' '}
          - Associação de Entregas X Equipe de Separação:
        </span>
        <strong>
          {selectedPicking ? `${selectedPicking.name} - ${selectedPicking.company_name}` : ''}
        </strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={localDispatch.onBtnSalvarClicked}
          btnLabel="Salvar"
          onVoltar={history.goBack}
        >
          <div className="p-grid">
            <div className="p-col-2">
              <CustomDropdown
                label={'Equipe: '}
                marginTop={0}
                optionLabel="name"
                options={state.equipes}
                value={state.selectedEquipe}
                onChange={value => localDispatch.onFormControlChange(value)}
              />
            </div>
          </div>
          <div className="p-grid mt-2">
            <div className="p-col-2" style={{ paddingTop: 15 }}>
              <CustomCheckbox
                checked={state.selecionarTodos}
                onChange={value => localDispatch.onSelecionarTodosChange(value)}
              >
                Selecionar Todos
              </CustomCheckbox>
            </div>
            <div className="p-col-3" style={{ paddingTop: 15 }}>
              <CustomCheckbox
                checked={state.selecionarTodos2Conferentes}
                onChange={value =>
                  localDispatch.onSelecionarTodos2ConferentesChange(value, selectedPicking.id)
                }
              >
                Selecionar Todos 2+ Conferentes
              </CustomCheckbox>
            </div>
          </div>
          {state.loadingMessage === LOAD_MESSAGE.NONE ||
          state.loadingMessage === LOAD_MESSAGE.SUCCESS ? (
            <div>
              <DataTable value={state.associationsAreaTeam}>
                <Column
                  field="selected"
                  style={tableCellCentered(50)}
                  body={assoc => {
                    return assoc.area_id ? (
                      <CustomCheckbox
                        checked={assoc.selected}
                        onChange={() => localDispatch.onCheckBoxRowClicked(assoc)}
                      />
                    ) : null
                  }}
                />
                <Column
                  field="area"
                  header="Área"
                  body={assoc => {
                    return assoc.area_id ? (
                      <span>{assoc.area}</span>
                    ) : (
                      <span style={{ color: 'red' }}>{assoc.area}</span>
                    )
                  }}
                />
                <Column field="area_nickname" header="Apelido" />
                <Column field="qte_deliveries" header="Qte. Entregas" style={tableCellCentered()} />
                <Column field="qte_sku" header="Qte. Skus" style={tableCellCentered()} />
                <Column
                  field="team"
                  header="Equipe"
                  body={entrega => <span style={{ color: '#0bbc0a' }}>{entrega.team}</span>}
                />
                <Column
                  field="any_checkers"
                  header="2+ Conferentes"
                  body={assoc => (
                    <CustomCheckbox
                      checked={assoc.any_checkers}
                      onChange={() =>
                        localDispatch.onAnyCheckersChange(
                          assoc,
                          selectedPicking.id,
                          !assoc.any_checkers,
                        )
                      }
                      disabled={!assoc.area_id}
                    />
                  )}
                  style={tableCellCentered()}
                />
              </DataTable>
            </div>
          ) : (
            <div></div>
          )}
        </CustomPanel>
      </div>
    </div>
  )
}
const mapStateToProps = ({ picking: { selectedPicking } }) => ({ selectedPicking })
export default connect(mapStateToProps)(withRouter(AssocEquipeSeparacao))
